import {IAction} from "src/context/IAction";
import {ISessionState} from "src/context/models/Session";
import {IErrorModel} from "src/context/states/IErrorModel";
import {SET_REGION_SUCCESS} from "src/context/actions/ActionTypes";

const SessionReducer = (state: ISessionState, {payload, type}: IAction): ISessionState => {
    switch (type) {
        case SET_REGION_SUCCESS:
            const updatedData = {
                ...state.data,
                region: payload
            };
            return {
                ...state,
                data: updatedData
            };
        default:
            return state;
    }
};

export default SessionReducer;
